import { PaxActionCardLink } from "@/shared/components/link/LinkOverride";
import { gradients } from "@/theme";
import { ChartBarIcon, ShoppingCartIcon, TagIcon } from "@phosphor-icons/react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { useTranslation } from "@ncino/pax-ui";
import { createFileRoute } from "@tanstack/react-router";
import { OrderFormBanner } from "@/shared/components/OrderFormBanner";
import { useIroncladWorkflow } from "@/services/ironclad/useIroncladWorkflow";

export const Route = createFileRoute("/_home/")({
  component: RouteComponent,
  staticData: {
    displayBreadcrumbs: false,
  },
});

function RouteComponent() {
  const { t } = useTranslation("_home");
  const theme = useTheme();
  const { userName } = Route.useRouteContext();
  const displayName = userName ?? t("homePage.defaultUserName");

  const { status, launch } = useIroncladWorkflow();
  const showOrderFormBanner = status === "unsigned" || status === "inProgress";

  const handleSignNow = () => launch();

  return (
    <Box sx={{ height: "100vh", overflowY: "auto" }}>
      {showOrderFormBanner && (
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 2,
            p: 2,
            backgroundColor: "background.default",
          }}
        >
          <OrderFormBanner onSignNow={handleSignNow} inProgress={status === "inProgress"} />
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "calc(100vh - 64px)",
        }}
      >
        <Typography variant="h5" sx={{ mb: 0.5 }}>
          {t("homePage.greeting", { displayName })}
        </Typography>

        <Typography
          variant="h3"
          sx={{
            background: gradients.gatorLinear,
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent",
            fontWeight: 700,
            mb: 5,
          }}
        >
          {t("homePage.welcomeMessage")}
        </Typography>

        <Box
          sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%", maxWidth: 700 }}
        >
          <PaxActionCardLink
            icon={<ShoppingCartIcon />}
            title={t("homePage.actionCards.browseToBuyTitle")}
            description={t("homePage.actionCards.browseToBuyMessage")}
            to={"/buy"}
            color={theme.palette.primary.main}
          />
          <PaxActionCardLink
            icon={<TagIcon />}
            title={t("homePage.actionCards.sellTitle")}
            description={t("homePage.actionCards.sellMessage")}
            to={"/sell"}
            color={theme.palette.primary.main}
          />
          <PaxActionCardLink
            icon={<ChartBarIcon />}
            title={t("homePage.actionCards.managePoolsTitle")}
            description={t("homePage.actionCards.managePoolsMessage")}
            to={"/manage"}
            search={{ tab: "sold" }}
            color={theme.palette.primary.main}
          />
        </Box>
      </Box>
    </Box>
  );
}
